import { render, staticRenderFns } from "./SlidePlayerLayout.vue?vue&type=template&id=9a8052bc&scoped=true"
import script from "./SlidePlayerLayout.vue?vue&type=script&lang=ts"
export * from "./SlidePlayerLayout.vue?vue&type=script&lang=ts"
import style0 from "./SlidePlayerLayout.vue?vue&type=style&index=0&id=9a8052bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8052bc",
  null
  
)

export default component.exports